export default {
  data() {
    return {
      selectedChildItems: [],
      choicesPrice: 0,
      currentModifierId: ''
    }
  },
  methods: {
    selectChoice(modifier, choice, preSelectQty, isChildPreSelected) {
      // find if choice is already selected with item_id and item_config_id
      let selectedChoice = this.selectedChildItems.find(
        (item) =>
          item.item_id === choice.itemid &&
          item.pick_list_id === modifier.pick_list_id &&
          (!choice.item_config_id || item.item_config_id === choice.item_config_id)
      )
      if (selectedChoice) {
        // if selected and quantity is 1, remove it from selectedChildItems by filtering it out by item_id pick_list_id and if choice has item_config_id by item_config_id
        if (selectedChoice.quantity === 1) {
          this.selectedChildItems = this.selectedChildItems.filter(
            (item) =>
              item.item_id !== choice.itemid ||
              item.pick_list_id !== modifier.pick_list_id ||
              (choice.item_config_id && item.item_config_id !== choice.item_config_id)
          )
        } else if (selectedChoice.quantity === 0) {
          // if quantity is 0, remove the choice
          this.selectedChildItems = this.selectedChildItems.filter(
            (item) =>
              item.item_id !== choice.itemid ||
              item.pick_list_id !== modifier.pick_list_id ||
              (choice.item_config_id && item.item_config_id !== choice.item_config_id)
          )
        }
      } else {
        // check if modifier is min 1 and max 1 or min 0 and max 1
        if ((modifier.mincount == 1 && modifier.maxcount == 1) || (modifier.mincount == 0 && modifier.maxcount == 1)) {
          let selectedChoices = this.selectedChildItems.filter((item) => item.pick_list_id === modifier.pick_list_id)
          if (selectedChoices.length > 0) {
            // Calculate current total quantity
            let currentTotal = selectedChoices.reduce((total, item) => {
              const originalChoice = modifier.pick_list_items?.find(c => c.itemid === item.item_id);
              return total + this.getEffectiveQuantity(item, originalChoice);
            }, 0);

            // If current total is already at maxcount, remove existing choices to make room for new one
            if (currentTotal >= modifier.maxcount) {
              // Remove existing choices to make room for new selection
              this.selectedChildItems = this.selectedChildItems.filter(
                (item) => item.pick_list_id !== modifier.pick_list_id
              )
            }

            // Check if the new choice has half variants and can be added as a half side
            if (choice.variants && choice.variants.length > 2) {
              let leftVariant = choice.variants.find((variant) => variant.style_name === 'Left');
              let rightVariant = choice.variants.find((variant) => variant.style_name === 'Right');

              if (leftVariant && rightVariant) {
                // If current total is 0.5 and new choice can be added as half, add as half side
                if (currentTotal === 0.5) {
                  // Check which side is already selected and choose the same side
                  let isLeftSelected = false;

                  selectedChoices.forEach((item) => {
                    if (item.style_id === leftVariant.item_style_id) {
                      isLeftSelected = true;
                    }
                  });

                  // Choose the same side
                  let selectedVariant = isLeftSelected ? leftVariant : rightVariant;

                  let choiceData = {
                    menu_id: choice.menuid,
                    price: selectedVariant.price,
                    name: choice.itemname,
                    quantity: preSelectQty ? preSelectQty : 1,
                    pick_list_id: modifier.pick_list_id,
                    item_id: choice.itemid,
                    item_config_id: choice.item_config_id,
                    category_id: choice.catid,
                    style_id: selectedVariant.item_style_id,
                    size_id: choice.item_size_id,
                    display_style: modifier.display_style,
                    free_up_to: modifier.free_up_to,
                  }
                  if (choice.variants) {
                    choiceData.size_id = choice.variants[0].item_size_id
                  }
                  if (isChildPreSelected) {
                    return choiceData
                  }
                  if (!this.checkIfPriceIsVisible(modifier, choice)) {
                    choiceData.price = 0
                  }
                  this.selectedChildItems.push(choiceData);
                  this.calculateChoicesPrice();
                  return;
                } else {
                  // Remove existing choices if they can't be combined
                  this.selectedChildItems = this.selectedChildItems.filter(
                    (item) => item.pick_list_id !== modifier.pick_list_id
                  )
                }
              } else {
                // Remove existing choices if new choice doesn't have half variants
                this.selectedChildItems = this.selectedChildItems.filter(
                  (item) => item.pick_list_id !== modifier.pick_list_id
                )
              }
            } else {
              // Remove existing choices if new choice doesn't have half variants
              this.selectedChildItems = this.selectedChildItems.filter(
                (item) => item.pick_list_id !== modifier.pick_list_id
              )
            }
          }
        }



        if (modifier?.display_style === 'bulk' && modifier.mincount === 0) {
          let selectedChoicesCount = this.selectedChildItems
            .filter(item => item.pick_list_id === modifier.pick_list_id)
            .reduce((total, item) => {
              const originalChoice = modifier.pick_list_items?.find(c => c.itemid === item.item_id);
              return total + this.getEffectiveQuantity(item, originalChoice);
            }, 0);

          let remainingSpace = modifier.maxcount - selectedChoicesCount;

          // If exactly 0.5 space remaining and choice has half variants, auto-select as half
          if (remainingSpace === 0.5 && choice.variants && choice.variants.length > 2) {
            let leftVariant = choice.variants.find((variant) => variant.style_name === 'Left');
            let rightVariant = choice.variants.find((variant) => variant.style_name === 'Right');

            if (leftVariant && rightVariant) {
              // Auto-select as half (prefer Left side)
              let choiceData = {
                menu_id: choice.menuid,
                price: leftVariant.price,
                name: choice.itemname,
                quantity: preSelectQty ? preSelectQty : 1,
                pick_list_id: modifier.pick_list_id,
                item_id: choice.itemid,
                item_config_id: choice.item_config_id,
                category_id: choice.catid,
                style_id: leftVariant.item_style_id,
                size_id: choice.item_size_id,
                display_style: modifier.display_style,
                free_up_to: modifier.free_up_to,
              }
              if (choice.variants) {
                choiceData.size_id = choice.variants[0].item_size_id
              }
              if (isChildPreSelected) {
                return choiceData
              }
              if (!this.checkIfPriceIsVisible(modifier, choice)) {
                choiceData.price = 0
              }
              this.selectedChildItems.push(choiceData);
              this.calculateChoicesPrice();
              return;
            }
          }

          if (selectedChoicesCount >= modifier.maxcount) {
            let toasterData = {
              show: true,
              message: "You can't select more than " + modifier.maxcount + ' choices for ' + "'" + modifier.prompt + "'",
            };
            this.SET_TOASTER(toasterData);
            return;
          }
        } else {
          if (modifier?.display_style === 'bulk') {
            let selectedChoicesCount = this.selectedChildItems
              .filter(item => item.pick_list_id === modifier.pick_list_id)
              .reduce((total, item) => {
                const originalChoice = modifier.pick_list_items?.find(c => c.itemid === item.item_id);
                return total + this.getEffectiveQuantity(item, originalChoice);
              }, 0);

            let effectiveMaxCount = modifier.mincount * this.itemQuantity;
            let remainingSpace = effectiveMaxCount - selectedChoicesCount;

            // If exactly 0.5 space remaining and choice has half variants, auto-select as half
            if (remainingSpace === 0.5 && choice.variants && choice.variants.length > 2) {
              let leftVariant = choice.variants.find((variant) => variant.style_name === 'Left');
              let rightVariant = choice.variants.find((variant) => variant.style_name === 'Right');

              if (leftVariant && rightVariant) {
                // Auto-select as half (prefer Left side)
                let choiceData = {
                  menu_id: choice.menuid,
                  price: leftVariant.price,
                  name: choice.itemname,
                  quantity: preSelectQty ? preSelectQty : 1,
                  pick_list_id: modifier.pick_list_id,
                  item_id: choice.itemid,
                  item_config_id: choice.item_config_id,
                  category_id: choice.catid,
                  style_id: leftVariant.item_style_id,
                  size_id: choice.item_size_id,
                  display_style: modifier.display_style,
                  free_up_to: modifier.free_up_to,
                }
                if (choice.variants) {
                  choiceData.size_id = choice.variants[0].item_size_id
                }
                if (isChildPreSelected) {
                  return choiceData
                }
                if (!this.checkIfPriceIsVisible(modifier, choice)) {
                  choiceData.price = 0
                }
                this.selectedChildItems.push(choiceData);
                this.calculateChoicesPrice();
                return;
              }
            }

            if (selectedChoicesCount >= effectiveMaxCount) {
              let toasterData = {
                show: true,
                message: "You can't select more than " + effectiveMaxCount + ' choices for ' + "'" + modifier.prompt + "'",
              };
              this.SET_TOASTER(toasterData);
              return;
            }
          }

          // Check if we should auto-select half side when there's exactly 0.5 space remaining
          let currentSelectedCount = this.selectedChildItems
            .filter(item => item.pick_list_id === modifier.pick_list_id)
            .reduce((total, item) => {
              const originalChoice = modifier.pick_list_items?.find(c => c.itemid === item.item_id);
              return total + this.getEffectiveQuantity(item, originalChoice);
            }, 0);

          let remainingSpace = modifier.maxcount - currentSelectedCount;

          // If exactly 0.5 space remaining and choice has half variants, auto-select as half
          if (remainingSpace === 0.5 && choice.variants && choice.variants.length > 2) {
            let leftVariant = choice.variants.find((variant) => variant.style_name === 'Left');
            let rightVariant = choice.variants.find((variant) => variant.style_name === 'Right');

            if (leftVariant && rightVariant) {
              // Auto-select as half (prefer Left side)
              let choiceData = {
                menu_id: choice.menuid,
                price: leftVariant.price,
                name: choice.itemname,
                quantity: preSelectQty ? preSelectQty : 1,
                pick_list_id: modifier.pick_list_id,
                item_id: choice.itemid,
                item_config_id: choice.item_config_id,
                category_id: choice.catid,
                style_id: leftVariant.item_style_id,
                size_id: choice.item_size_id,
                display_style: modifier.display_style,
                free_up_to: modifier.free_up_to,
              }
              if (choice.variants) {
                choiceData.size_id = choice.variants[0].item_size_id
              }
              if (isChildPreSelected) {
                return choiceData
              }
              if (!this.checkIfPriceIsVisible(modifier, choice)) {
                choiceData.price = 0
              }
              this.selectedChildItems.push(choiceData);
              this.calculateChoicesPrice();
              return;
            }
          }

          if (!this.checkMinMax(modifier)) {
            let toasterData = {
              show: true,
              message: "You can't select more than " + modifier.maxcount + ' choices for ' + "'" + modifier.prompt + "'",
            };
            this.SET_TOASTER(toasterData);
            return;
          }
        }
        // find the variant with style_name Whole
        let wholeVariant = null
        if (choice.variants) {
          wholeVariant = choice.variants.find((variant) => variant.style_name === 'Whole')
        }
        let choiceData = {
          menu_id: choice.menuid,
          price: wholeVariant ? wholeVariant.price : choice.baseprice,
          name: choice.itemname,
          quantity: preSelectQty ? preSelectQty : 1,
          pick_list_id: modifier.pick_list_id,
          item_id: choice.itemid,
          item_config_id: choice.item_config_id,
          category_id: choice.catid,
          style_id: wholeVariant ? wholeVariant.item_style_id : choice.item_style_id,
          size_id: choice.item_size_id,
          display_style: modifier.display_style,
          free_up_to: modifier.free_up_to,
        }
        if (choice.variants) {
          choiceData.size_id = choice.variants[0].item_size_id
        }
        if (isChildPreSelected) {
          return choiceData
        }
        if (!this.checkIfPriceIsVisible(modifier, choice)) {
          choiceData.price = 0
        }
        this.selectedChildItems.push(choiceData);
      }
      this.calculateChoicesPrice()
    },
    checkIfSelected(modifier, choice) {
      let selectedChoice = this.selectedChildItems.find(
        (item) =>
          item.item_id === choice.itemid &&
          item.pick_list_id === modifier.pick_list_id &&
          (!choice.item_config_id || item.item_config_id === choice.item_config_id)
      )
      if (selectedChoice) {
        if (choice.item_style_id) {
          return selectedChoice.style_id === choice.item_style_id
        }
        return true
      }
      return false
    },
    checkIfShouldScrollToNext(modifier) {
      if (modifier.maxcount !== 0 && this.getQtyOfModifier(modifier) >= modifier.maxcount) {
        const modifierIndex = this.getModifiers.findIndex((mod) => mod.pick_list_id === modifier.pick_list_id);
        const nextModifier = document.querySelectorAll('.modifier')[modifierIndex + 1];
        if (nextModifier) {
          nextModifier.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },
    getQtyOfModifier(modifier) {
      let selectedChoices = this.selectedChildItems.filter((item) => item.pick_list_id === modifier.pick_list_id)
      let totalQty = 0
      selectedChoices.forEach((choice) => {
        // Find the original choice data to check if it's a half side
        const originalChoice = modifier.pick_list_items?.find(c => c.itemid === choice.item_id);
        const effectiveQty = this.getEffectiveQuantity(choice, originalChoice);
        totalQty += effectiveQty
      })
      return totalQty
    },
    checkMinMax(modifier) {
      let selectedChoices = this.selectedChildItems.filter((item) => item.pick_list_id === modifier.pick_list_id)
      // get the total quantity of selected choices
      let totalQuantity = 0
      selectedChoices.forEach((choice) => {
        // Find the original choice data to check if it's a half side
        const originalChoice = modifier.pick_list_items?.find(c => c.itemid === choice.item_id);
        const effectiveQty = this.getEffectiveQuantity(choice, originalChoice);
        totalQuantity += effectiveQty
      })
      if (totalQuantity + 1 < modifier.mincount) {
        return true
      } else if (totalQuantity + 1 > modifier.maxcount) {
        return false
      } else {
        return true
      }
    },
    getSelectedCount(itemId) {
      let count = 0
      this.selectedChildItems.forEach((item) => {
        if (item.item_id === itemId) {
          if (item.child_items && item.child_items.length > 0) {
            count = item.child_items.length
          }
        }
      })
      return count
    },
    getSelectedChildItemNames(itemId, pickListId) {
      let names = []
      this.selectedChildItems.forEach((item) => {
        if (item.item_id === itemId && item.pick_list_id === pickListId) {
          if (item.child_items && item.child_items.length > 0) {
            item.child_items.forEach((childItem) => {
              if (childItem.display_style != 'hidden') {
                names.push(childItem.name)
              }
            })
          }
        }
      })
      return names.join(', ')
    },
    getMinMax(modifier) {
      let minMax;
      const mincount = modifier?.display_style === 'bulk' ? this.itemQuantity : modifier.mincount;

      if (modifier.display_style === 'bulk' && modifier.mincount == 0) {
        return '';
      }

      if (mincount == 0 && modifier.maxcount == 99) {
        minMax = '';
      } else if (mincount == 0 && modifier.maxcount != 0) {
        minMax = 'SELECT UP TO ' + modifier.maxcount;
      } else if (mincount == modifier.maxcount) {
        minMax = 'SELECT ' + mincount;
      } else if (mincount != 0 && modifier.maxcount == 99) {
        minMax = 'SELECT AT LEAST ' + mincount;
      } else if (mincount != 0 && modifier.maxcount != 0) {
        minMax = 'SELECT ' + mincount + ' TO ' + modifier.maxcount;
      }
      if (modifier.free_up_to) {
        minMax = 'FREE UP TO ' + modifier.free_up_to + (minMax ? ' and ' + minMax : '');
      }
      return minMax
    },
    getPizzaSidePrice(choice) {
      // Resolve the modifier to scope selection correctly
      let modifier = null;
      if (this.getModifiers) {
        modifier = this.getModifiers.find(mod =>
          mod.pick_list_items?.some(item => item.itemid === choice.itemid)
        );
      }

      // Find the selected choice scoped to the same pick_list and config
      let selectedChoice = null;
      if (modifier) {
        selectedChoice = this.selectedChildItems.find((item) =>
          item.item_id === choice.itemid &&
          item.pick_list_id === modifier.pick_list_id &&
          (!choice.item_config_id || item.item_config_id === choice.item_config_id)
        );
      } else {
        selectedChoice = this.selectedChildItems.find((item) =>
          item.item_id === choice.itemid && (!choice.item_config_id || item.item_config_id === choice.item_config_id)
        );
      }

      if (selectedChoice) {
        if (modifier && modifier.free_up_to) {
          // Compute how much of this choice is chargeable (supports partials when totals shift)
          const proportion = this.getChargedProportionForChoice(modifier, choice);
          const chargeAmount = (selectedChoice.price ?? 0) * Math.max(0, Math.min(1, proportion));
          return this.formatPrice(chargeAmount);
        }

        return this.formatPrice(selectedChoice.price)
      }
    },
    getChargedProportionForChoice(modifier, choice) {
      if (!modifier?.free_up_to || modifier.free_up_to === 0) return 1;

      // Gather selected choices within this modifier
      const selectedChoices = this.selectedChildItems.filter(
        (item) => item.pick_list_id === modifier.pick_list_id
      );
      if (selectedChoices.length === 0) return 1;

      // Helper to get original choice (for variants/base price)
      const getOriginalChoice = (item) =>
        modifier.pick_list_items?.find((c) => c.itemid === item.item_id) || null;

      // Stable base price for sorting free items
      const getStableBasePrice = (item, original) => {
        if (!original) return item.price ?? 0;
        if (original.variants && original.variants.length > 0) {
          const whole = original.variants.find((v) => v.style_name === 'Whole');
          return whole ? (whole.price ?? 0) : original.baseprice ?? (item.price ?? 0);
        }
        return original.baseprice ?? (item.price ?? 0);
      };

      // Decorate and sort by base price ascending
      const decorated = selectedChoices
        .map((item) => {
          const original = getOriginalChoice(item);
          return {
            ref: item,
            original,
            effectiveQuantity: this.getEffectiveQuantity(item, original),
            sortPrice: getStableBasePrice(item, original),
          };
        })
        .sort((a, b) => a.sortPrice - b.sortPrice);

      const freeLimit = modifier.free_up_to;
      let cumulative = 0;

      for (const entry of decorated) {
        const qty = entry.effectiveQuantity ?? (entry.ref.quantity ?? 1);
        const isTarget =
          entry.ref.item_id === choice.itemid &&
          (!choice.item_config_id || entry.ref.item_config_id === choice.item_config_id);

        if (isTarget) {
          if (cumulative >= freeLimit) {
            return 1; // fully charged
          }
          if (cumulative + qty <= freeLimit) {
            return 0; // fully free
          }
          const chargeablePortion = cumulative + qty - freeLimit; // 0..qty
          return Math.max(0, Math.min(1, chargeablePortion / qty));
        }

        cumulative += qty;
      }

      return 1; // default: charged
    },
    checkIfSideSelected(choice, sideName) {
      // Resolve modifier to scope lookup
      let modifier = null;
      if (this.getModifiers) {
        modifier = this.getModifiers.find(mod =>
          mod.pick_list_items?.some(item => item.itemid === choice.itemid)
        );
      }

      let selectedChoice = this.selectedChildItems.find((item) =>
        item.item_id === choice.itemid &&
        (!modifier || item.pick_list_id === modifier.pick_list_id) &&
        (!choice.item_config_id || item.item_config_id === choice.item_config_id)
      )
      if (selectedChoice && choice.variants?.length > 2) {
        let sideStyle = choice.variants.find((variant) => variant.style_name === sideName)
        if (sideStyle && sideStyle.item_style_id) {
          if (selectedChoice.style_id === sideStyle.item_style_id) {
            return true
          } else {
            return false
          }
        }
      }
    },
    selectSide(choice, sideName) {
      let sideStyle = choice.variants.find((variant) => variant.style_name === sideName)

      // Find the modifier for this choice to check maxcount
      let modifier = null;
      if (this.getModifiers) {
        modifier = this.getModifiers.find(mod =>
          mod.pick_list_items?.some(item => item.itemid === choice.itemid)
        );
      }

      if (modifier) {
        // Find the exact selected choice in this modifier scope
        var selectedChoice = this.selectedChildItems.find((item) =>
          item.item_id === choice.itemid &&
          item.pick_list_id === modifier.pick_list_id &&
          (!choice.item_config_id || item.item_config_id === choice.item_config_id)
        )

        // Calculate current total quantity for this modifier excluding the choice we're modifying
        let currentTotal = this.selectedChildItems
          .filter(item => item.pick_list_id === modifier.pick_list_id && item.item_id !== choice.itemid)
          .reduce((total, item) => {
            const originalChoice = modifier.pick_list_items?.find(c => c.itemid === item.item_id);
            return total + this.getEffectiveQuantity(item, originalChoice);
          }, 0);

        // Calculate quantity for the new side selection
        let newQuantity;
        if (sideName === 'Left' || sideName === 'Right') {
          newQuantity = 0.5; // Half sides take 0.5 space
        } else {
          newQuantity = 1.0; // Whole takes 1.0 space
        }

        // Check if the new selection would exceed maxcount
        if (currentTotal + newQuantity > modifier.maxcount) {
          let toasterData = {
            show: true,
            message: "You can't select " + sideName + " as it would exceed the maximum of " + modifier.maxcount + " choices for '" + modifier.prompt + "'",
          };
          this.SET_TOASTER(toasterData);
          return; // Prevent the side change
        }
      }

      if (selectedChoice) {
        selectedChoice.style_id = sideStyle.item_style_id

        // Use the variant's actual price (API already provides correct half prices)
        selectedChoice.price = sideStyle.price

        this.calculateChoicesPrice()
      }
    },
    isHalfSide(item, choice) {
      if (!choice?.variants || choice.variants.length <= 2) return false;

      const leftVariant = choice.variants.find(v => v.style_name === 'Left');
      const rightVariant = choice.variants.find(v => v.style_name === 'Right');

      return (leftVariant && item.style_id === leftVariant.item_style_id) ||
        (rightVariant && item.style_id === rightVariant.item_style_id);
    },

    getEffectiveQuantity(item, choice) {
      return this.isHalfSide(item, choice) ? item.quantity * 0.5 : item.quantity;
    },

    getEffectivePrice(item) {
      // Return the actual item price (API already provides correct prices for all variants)
      return item.price;
    },
    calculateChoicesPrice() {
      let price = 0;
      let itemCount = {};

      // We need to store original choices data to access variants info
      const getOriginalChoice = (item) => {
        // Try to find the choice from modifiers in the current context
        if (this.getModifiers) {
          for (const modifier of this.getModifiers) {
            const choice = modifier.pick_list_items?.find(c => c.itemid === item.item_id);
            if (choice) return choice;
          }
        }
        return null;
      };

      const sortItemsByPriceAndFreeUpTo = (items) => {
        return items.sort((a, b) => {
          // Use stable base price (Whole/baseprice) to decide free vs paid ordering
          const aOriginal = getOriginalChoice(a);
          const bOriginal = getOriginalChoice(b);
          const getStableBasePrice = (item, original) => {
            if (!original) return item.price;
            if (original.variants && original.variants.length > 0) {
              const whole = original.variants.find(v => v.style_name === 'Whole');
              return whole ? whole.price : (original.baseprice ?? item.price);
            }
            return original.baseprice ?? item.price;
          };
          const aSortPrice = getStableBasePrice(a, aOriginal);
          const bSortPrice = getStableBasePrice(b, bOriginal);

          return aSortPrice - bSortPrice;
        });
      };

      const calculatePrice = (items, itemCount) => {
        const sortedItems = sortItemsByPriceAndFreeUpTo(items);
        sortedItems.forEach((item) => {
          const originalChoice = getOriginalChoice(item);
          const effectiveQuantity = this.getEffectiveQuantity(item, originalChoice);
          const effectivePrice = this.getEffectivePrice(item);

          if (!itemCount[item.pick_list_id]) {
            itemCount[item.pick_list_id] = { quantity: 0, price: 0 };
          }

          const previousQuantity = itemCount[item.pick_list_id].quantity;
          itemCount[item.pick_list_id].quantity += effectiveQuantity;
          itemCount[item.pick_list_id].price = effectivePrice;

          // Calculate how much of this item should be charged
          const freeLimit = item.free_up_to || 0;
          const totalAfterThis = itemCount[item.pick_list_id].quantity;

          if (totalAfterThis > freeLimit) {
            // Some or all of this item needs to be charged proportionally
            const freePortionOfThisItem = Math.max(0, freeLimit - previousQuantity);
            const chargeablePortionOfThisItem = Math.max(0, effectiveQuantity - freePortionOfThisItem);

            if (chargeablePortionOfThisItem > 0) {
              const proportion = effectiveQuantity > 0 ? (chargeablePortionOfThisItem / effectiveQuantity) : 0;
              const amountToCharge = (effectivePrice * item.quantity) * proportion;
              price += amountToCharge;
            }
          }

          if (item.child_items) {
            let childItemCount = {};
            calculatePrice(item.child_items, childItemCount);
          }
        });
      };
      calculatePrice(this.selectedChildItems, itemCount);
      this.choicesPrice = price;
    },
    checkExpandedChoices(choice) {
      // check if choice is expanded
      let expanded = this.openNutritionChoicesIds.find((item) => item.id === choice.itemid)
      if (expanded) {
        return true
      }
      return false
    },
    expandNutritionInfo(choice) {
      // check if choice is already expanded
      let expanded = this.openNutritionChoicesIds.find((item) => item.id === choice.itemid)
      if (expanded) {
        // remove from array
        this.openNutritionChoicesIds = this.openNutritionChoicesIds.filter((item) => item.id !== choice.itemid)
      } else {
        // add to array
        this.openNutritionChoicesIds.push({ id: choice.itemid })
      }
    },
    getMultiChoiceQuantity(choice) {
      let selectedChoice = this.selectedChildItems.find((item) => item.item_id === choice.itemid)
      if (selectedChoice) {
        return selectedChoice.quantity
      }
    },
    changeChoiceQty(type, choice, modifier) {
      let originalChoiceQty = this.getMultiChoiceQuantity(choice)
      let selectedChoice = this.selectedChildItems.find((item) => item.item_id === choice.itemid)
      // check max qty of the item
      if (choice.max_qty) {
        if (type === 'plus' && selectedChoice.quantity === choice.max_qty) {
          let toasterData = {
            show: true,
            message: 'Maximum quantity you can select is ' + choice.max_qty + ' for ' + choice.itemname,
          }
          this.SET_TOASTER(toasterData)
          return
        }
      }

      if (type === 'minus') {
        if (selectedChoice.quantity > 1) {
          selectedChoice.quantity = selectedChoice.quantity - 1
        }
      } else if (type === 'plus') {
        if (selectedChoice.quantity == 99) {
          return
        }

        if (modifier?.display_style === 'bulk' && modifier.mincount === 0) {
          let totalQuantity = this.selectedChildItems
            .filter((item) => item.pick_list_id === modifier.pick_list_id)
            .reduce((total, item) => {
              const originalChoice = modifier.pick_list_items?.find(c => c.itemid === item.item_id);
              return total + this.getEffectiveQuantity(item, originalChoice);
            }, 0);

          if (totalQuantity >= modifier.maxcount) {
            let toasterData = {
              show: true,
              message: "You can't select more than " + modifier.maxcount + ' choices for ' + "'" + modifier.prompt + "'",
            };
            this.SET_TOASTER(toasterData);
            return;
          }
        } else {
          if (!this.checkMinMax(modifier)) {
            let toasterData = {
              show: true,
              message: "You can't select more than " + modifier.maxcount + ' choices for ' + "'" + modifier.prompt + "'",
            };
            this.SET_TOASTER(toasterData);
            return;
          }

          if (modifier?.display_style === 'bulk') {
            let totalChoiceQuantity = this.selectedChildItems
              .filter((childItem) => childItem.pick_list_id === modifier.pick_list_id)
              .reduce((total, childItem) => {
                const originalChoice = modifier.pick_list_items?.find(c => c.itemid === childItem.item_id);
                return total + this.getEffectiveQuantity(childItem, originalChoice);
              }, 0);

            if (totalChoiceQuantity >= this.itemQuantity) {
              let toasterData = {
                show: true,
                message: "You can't select more than " + this.itemQuantity + ' items in total.',
              };
              this.SET_TOASTER(toasterData);
              return;
            }
          }
        }

        selectedChoice.quantity = selectedChoice.quantity + 1;
      }

      // check if selectedChoice has child items
      if (selectedChoice.child_items) {
        // multiply the quantity of each child item by selectedChoice quantity
        selectedChoice.child_items.forEach((childItem) => {
          let qtyForOne = childItem.quantity / originalChoiceQty
          childItem.quantity = qtyForOne * selectedChoice.quantity
        })
      }
      this.checkIfShouldScrollToNext(modifier)
      this.calculateChoicesPrice()
    },
    checkTotalChoiceQuantity() {
      let totalChoiceQuantity = this.selectedChildItems.reduce((total, item) => {
        // Find the original choice data to determine if it's a half side
        const originalChoice = this.findOriginalChoiceFromContext(item);
        return total + this.getEffectiveQuantity(item, originalChoice);
      }, 0)
      return totalChoiceQuantity === this.itemQuantity
    },
    findOriginalChoiceFromContext(item) {
      // Helper method to find original choice from available context
      if (this.getModifiers) {
        for (const modifier of this.getModifiers) {
          const choice = modifier.pick_list_items?.find(c => c.itemid === item.item_id);
          if (choice) return choice;
        }
      }
      return null;
    },
    isChoiceFree(modifier, choice) {
      if (!modifier.free_up_to || modifier.free_up_to === 0) {
        return false;
      }

      // Get all selected choices for this modifier
      const selectedChoices = this.selectedChildItems.filter(item => item.pick_list_id === modifier.pick_list_id);

      // If no choices selected, return false (price should show normally)
      if (selectedChoices.length === 0) {
        return false;
      }

      // Check if current choice is selected
      const currentSelectedChoice = selectedChoices.find(item =>
        item.item_id === choice.itemid &&
        (!choice.item_config_id || item.item_config_id === choice.item_config_id)
      );

      // Only check if the choice is actually selected
      if (!currentSelectedChoice) {
        return false;
      }

      // Create list with base prices and quantities for stable free assignment
      const allChoicesWithPrices = selectedChoices.map(item => {
        const originalChoice = modifier.pick_list_items?.find(c => c.itemid === item.item_id);
        // Use base price (Whole variant price if available, otherwise baseprice) to keep ordering stable
        let baseDisplayPrice = item.price;
        if (originalChoice) {
          if (originalChoice.variants && originalChoice.variants.length > 0) {
            const wholeVariant = originalChoice.variants.find(v => v.style_name === 'Whole');
            baseDisplayPrice = wholeVariant ? wholeVariant.price : (originalChoice.baseprice ?? item.price);
          } else {
            baseDisplayPrice = originalChoice.baseprice ?? item.price;
          }
        }
        return {
          ...item,
          effectiveQuantity: this.getEffectiveQuantity(item, originalChoice),
          effectivePrice: baseDisplayPrice
        };
      });

      // Sort by stable base price (cheapest first), then by itemid for consistency
      allChoicesWithPrices.sort((a, b) => {

        return a.effectivePrice - b.effectivePrice;
      });

      // Calculate cumulative count up to this choice using effective quantities (halves count as 0.5)
      let cumulativeCount = 0;
      for (const item of allChoicesWithPrices) {
        const selectionCountIncrement = item.effectiveQuantity ?? (item.quantity ?? 1);
        // Check if this is the choice we're checking
        if (item.item_id === choice.itemid &&
          (!choice.item_config_id || item.item_config_id === choice.item_config_id)) {
          // Only mark as free if the entire selection fits within the free limit by effective count
          return (cumulativeCount + selectionCountIncrement) <= modifier.free_up_to;
        }

        // Increment by effective quantity so two halves sum to one
        cumulativeCount += selectionCountIncrement;
      }

      return false;
    },
    checkRequiredSelections(modifiers) {
      let requiredSelectionsComplete = true
      for (let [index, modifier] of modifiers.entries()) {
        // check if modifier is required
        if (modifier.mincount != 0) {
          // get selected choices of the modifier
          let selectedChoices = this.selectedChildItems.filter((item) => item.pick_list_id === modifier.pick_list_id)
          // add all of the effective quantities of selected choices
          let selectedChoicesQuantity = selectedChoices.reduce((total, item) => {
            const originalChoice = modifier.pick_list_items?.find(c => c.itemid === item.item_id);
            return total + this.getEffectiveQuantity(item, originalChoice);
          }, 0)
          // check if selected choices are less than mincount
          if (selectedChoicesQuantity < modifier.mincount) {
            // show toaster
            let toasterData = {
              show: true,
              message: 'You must select at least ' + modifier.mincount + ' choices for ' + "'" + modifier.prompt + "'",
            }
            this.SET_TOASTER(toasterData)
            // shake modifier
            let modifierElement = document.getElementsByClassName('modifier')[index]
            modifierElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            })
            modifierElement.classList.add('shake')
            // check if modifier is already in expandedModifiers
            let expanded = this.expandedModifiers.find((item) => item.pick_list_id === modifier.pick_list_id)
            if (!expanded) {
              this.expandedModifiers.push({ pick_list_id: modifier.pick_list_id })
            }
            setTimeout(() => {
              modifierElement.classList.remove('shake')
            }, 1500)
            requiredSelectionsComplete = false
            break
          }
        }
      }
      return requiredSelectionsComplete
    },
    checkIfHasRequiredNestedModifiers(modifier, choice) {
      let hasRequiredNestedModifiers = false
      // check if choice has child items
      if (choice.child_pick_list_data && this.checkIfSelected(modifier, choice)) {
        // go through each modifier
        choice.child_pick_list_data.pick_lists.forEach((modifier) => {
          // check if modifier is required
          if (modifier.mincount != 0) {
            // get the index of the choice in selectedChildItems
            let selectedChoiceIndex = this.selectedChildItems.findIndex((item) => item.item_id === choice.itemid)
            // get selected choices of the modifier
            if (!this.selectedChildItems[selectedChoiceIndex].child_items) {
              hasRequiredNestedModifiers = true
            } else {
              let selectedChoices = this.selectedChildItems[selectedChoiceIndex].child_items.filter(
                (item) => item.pick_list_id === modifier.pick_list_id
              )
              // check if selected choices are less than mincount
              if (selectedChoices.length < modifier.mincount) {
                hasRequiredNestedModifiers = true
              }
            }
          }
          modifier.pick_list_items.forEach((subChoice) => {
            // find the index of the parent choice in selectedChildItems
            let parentChoiceIndex = this.selectedChildItems.findIndex((item) => item.item_id === choice.itemid)
            // check if choice has child items
            if (subChoice.child_pick_list_data) {
              // go through each modifier
              subChoice.child_pick_list_data.pick_lists.forEach((subModifier) => {
                // check if modifier is required and selected
                if (
                  subModifier.mincount != 0 &&
                  this.checkIfNestedSelected(subModifier, subChoice, parentChoiceIndex)
                ) {
                  if (parentChoiceIndex >= 0 && this.selectedChildItems[parentChoiceIndex].child_items) {
                    // find subChoice index in selectedChildItems
                    let subChoiceIndex = this.selectedChildItems[parentChoiceIndex].child_items.findIndex(
                      (item) => item.item_id === subChoice.itemid
                    )
                    if (subChoiceIndex) {
                      if (!this.selectedChildItems[parentChoiceIndex].child_items[subChoiceIndex].child_items) {
                        hasRequiredNestedModifiers = true
                      } else {
                        // get selected choices of the modifier
                        let selectedChoices = this.selectedChildItems[parentChoiceIndex].child_items[
                          subChoiceIndex
                        ].child_items.filter((item) => item.pick_list_id === subModifier.pick_list_id)
                        // check if selected choices are less than mincount
                        if (selectedChoices.length < subModifier.mincount) {
                          hasRequiredNestedModifiers = true
                        } else {
                          hasRequiredNestedModifiers = false
                        }
                      }
                    }
                  }
                }
              })
            }
          })
        })
      }
      return hasRequiredNestedModifiers
    },
    checkIfNestedSelected(modifier, choice, parentChoiceIndex) {
      let selectedChoice = this.selectedChildItems[parentChoiceIndex].child_items?.find(
        (item) => item.item_id === choice.itemid
      )
      if (selectedChoice) {
        return true
      }
    },
    checkIfPriceIsVisible(modifier, choice) {
      // check if defaults are free
      if (modifier.defaults_are_free) {
        // check if choice has price and choice is default (preselected)
        if (choice.baseprice != 0 && choice.default_qty > 0) {
          return false
        }
        // check if choice has price and choice is not default (preselected)
        else if (choice.baseprice != 0 && choice.default_qty == 0) {
          return true
        } else {
          return false
        }
      }

      if (choice.baseprice != 0) {
        return true
      } else {
        return false
      }
    },
    getPreSelectedChoices(modifiers) {
      modifiers.forEach((modifier) => {
        // go through each choice
        modifier.pick_list_items.forEach((choice) => {
          let parentChoiceIndex
          // check if choice is preselected
          if (choice.default_qty != 0) {
            // add it to selectedChildItems
            this.selectChoice(modifier, choice, choice.default_qty, null, 'modal')
          }
          if (modifier?.mincount != 0) {
            // if the modifier is mandatory, add it to expandedModifiers if it has
            this.expandedModifiers.push({ pick_list_id: modifier.pick_list_id })
          }
          // if choice has child items go through each child item
          if (choice.child_pick_list_data && choice.default_qty != 0) {
            choice.child_pick_list_data.pick_lists.forEach((modifier) => {
              // go through each choice
              modifier.pick_list_items.forEach((subChoice) => {
                // check if choice is preselected
                if (subChoice.default_qty != 0) {
                  // get choice data
                  let choiceData = this.selectChoice(modifier, subChoice, choice.default_qty, true, 'modal')
                  // find the index of parent choice in selectedChildItems
                  parentChoiceIndex = this.selectedChildItems.findIndex(
                    (item) =>
                      item.item_id === choice.itemid &&
                      (!choice.item_config_id || item.item_config_id === choice.item_config_id)
                  )
                  // if child_items array doesn't exist create it and add choiceData to it
                  if (parentChoiceIndex != -1) {
                    if (!this.selectedChildItems[parentChoiceIndex].child_items) {
                      this.selectedChildItems[parentChoiceIndex].child_items = []
                      this.selectedChildItems[parentChoiceIndex].child_items.push(choiceData)
                    } else {
                      // if child_items array exists add choiceData to it
                      this.selectedChildItems[parentChoiceIndex].child_items.push(choiceData)
                    }
                  }
                }
                // if choice has child items go through each child item
                if (subChoice.child_pick_list_data) {
                  subChoice.child_pick_list_data.pick_lists.forEach((modifier) => {
                    // go through each choice
                    modifier.pick_list_items.forEach((subSubChoice) => {
                      // check if choice is preselected
                      if (subSubChoice.default_qty != 0) {
                        // get choice data
                        let choiceData = this.selectChoice(modifier, subSubChoice, choice.default_qty, true, 'modal')
                        // find the index of parent choice in selectedChildItems[parentChoiceIndex].child_items
                        let subParentChoiceIndex = this.selectedChildItems[parentChoiceIndex].child_items.findIndex(
                          (item) => item.item_id === subChoice.itemid
                        )
                        // if child_items array doesn't exist create it and add choiceData to it
                        if (subParentChoiceIndex != -1) {
                          if (
                            !this.selectedChildItems[parentChoiceIndex].child_items[subParentChoiceIndex].child_items
                          ) {
                            this.selectedChildItems[parentChoiceIndex].child_items[subParentChoiceIndex].child_items =
                              []
                            this.selectedChildItems[parentChoiceIndex].child_items[
                              subParentChoiceIndex
                            ].child_items.push(choiceData)
                          } else {
                            // if child_items array exists add choiceData to it
                            this.selectedChildItems[parentChoiceIndex].child_items[
                              subParentChoiceIndex
                            ].child_items.push(choiceData)
                          }
                        }
                      }
                    })
                  })
                }
              })
            })
          }
        })
      })
    },
  },
}
